export default "__VITE_ASSET__BJwPQE5K__"